var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Menu as MuiMenu } from '@mui/material';
import MenuItem from '../MenuItem';
import { useCallback, useRef } from 'react';
import { getAnchorTransformOrigin } from '../../utils/menu';
export default function Menu(props) {
    var defaultItems = props.items, onClick = props.onClick, open = props.open, onClose = props.onClose, anchorEl = props.anchorEl, _a = props.anchorOrigin, anchorOrigin = _a === void 0 ? 'bottom-right' : _a, _b = props.transformOrigin, transformOrigin = _b === void 0 ? 'top-right' : _b;
    var items = useRef(defaultItems).current;
    var onClickItem = useCallback(function (value) {
        onClick(value);
        onClose();
    }, []);
    return (_jsx(MuiMenu, __assign({ anchorOrigin: getAnchorTransformOrigin(anchorOrigin), transformOrigin: getAnchorTransformOrigin(transformOrigin), open: open, closeAfterTransition: true, onBackdropClick: onClose, onClose: onClose, anchorEl: anchorEl }, { children: items.map(function (item, index) { return (_jsx(MenuItem, __assign({}, item, { onClick: onClickItem, tabIndex: index }), item.value)); }) })));
}
